import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface FieldAlyticsSite {
  id: string;
  name: string;
  blenderIds: string[];
}

const useGetFieldAlyticsSites = (options?: QueryOptions<FieldAlyticsSite[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrEmployeeQuery<FieldAlyticsSite[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/sites` },
    { ...options, rewriteToEmployeeApi: false }
  );
};

export default useGetFieldAlyticsSites;
